import React from 'react'
import { Button } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import InfoSection from './InfoSection';

import '../../../assets/sass/pages/landing/layout/footer.scss';

const Footer = ({ info }) => {
    return (
        <>
            <InfoSection infos={info} />
            <footer className="footer-landing">
                <Button
                    variant="link"
                    as={NavLink}
                    to="/contact-us"
                    className="sm"
                >Contact Us</Button>
                <Button
                    variant="link"
                    as={NavLink}
                    to="/pricing"
                    className="sm"
                >Pricing</Button>
            </footer>
        </>
    )
}

Footer.defaultProps = {
    info: [
        {
            title: 'viedos',
            number: 300
        },
        {
            title: 'players data',
            number: 450
        },
        {
            title: 'app users',
            number: 1400
        },
        {
            title: 'teams',
            number: 89
        },
    ]
}

export default Footer
